import { squareFeetPerAcre, squareMetersPerAcre } from "../constants/unitsSystems";
import store from "../store";

export const squareFeetToAcres = (area: number) => area / squareFeetPerAcre;

export const squareMetersToAcres = (area: number) => area / squareMetersPerAcre;

export const amountOfAcres = (area: number) =>
  store.getState().users.metric ? squareMetersToAcres(area) : squareFeetToAcres(area);
